/* @ngInject */
function BindCampaignDialogController ($scope) {
  $scope.campaignId = null

  const api = {}

  this.getApi = () => api

  activate()

  function activate () {
    $scope.campaignId = $scope.data?.campaignId

    if ($scope.data?.currentModule) {
      $scope.currentModule = $scope.data.currentModule
    }
  }

  $scope.unbindCampaign = (assetId) => {
    $scope.close(assetId)
  }

  $scope.closeDialog = function () {
    $scope.close()
  }
}

export { BindCampaignDialogController }
